module.exports = __webpack_public_path__ + "52ebabd21c19e6ef2b668bf2331f4fa8.svg";